import { useInfiniteQuery } from 'react-query'

import { Dataset } from '../../../types/dataset'
import { Results } from '../../../types/pagination'
import { get } from '../../../utils/api'
import { getOffsetFromUrl, getQueryString } from '../../../utils/queryString'

export const useDatasets = () => {
  const limit = 20

  const {
    data: response,
    isLoading,
    hasNextPage,
    fetchNextPage,
  } = useInfiniteQuery(
    [`data-ingestions`],
    ({ pageParam }) =>
      get<Results<Dataset>>(
        `/data-ingestions/?${getQueryString({
          offset: pageParam,
          limit,
        })}`
      ),
    {
      getNextPageParam: (lastPage) => getOffsetFromUrl(lastPage.next),
      retry: false,
      keepPreviousData: true,
    }
  )

  const data = response?.pages.map((p) => p.results).flat() || []
  const isEmpty = !isLoading && data.length === 0

  return {
    data,
    isLoading,
    isEmpty,
    hasNextPage,
    fetchNextPage,
  }
}
